// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Upm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000012.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>校内语言团培</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>大学雅思和美研</div>
                            </div>
                            {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                <div className='flex-col'>
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000076.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000077.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000078.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000079.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000080.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000081.jpg")} />
                                </div>
                            </div>}

                            {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                <div className='flex-col'>
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000082.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000083.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000084.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000085.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000086.jpg")} />
                                    <LazyImage imgUrl={require("./assets/img/convoy/55_000087.jpg")} />
                                </div>
                            </div>}

                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Upm);